import { render, staticRenderFns } from "./CodexData.vue?vue&type=template&id=54acb2d4&scoped=true&"
import script from "./CodexData.vue?vue&type=script&lang=js&"
export * from "./CodexData.vue?vue&type=script&lang=js&"
import style0 from "../components/css/Style.css?vue&type=style&index=0&id=54acb2d4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54acb2d4",
  null
  
)

export default component.exports